"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import type { ReactNode } from "react";
const QUICK_VOTE_RESTART_VISIBILITY_DELAY_MS = 200;
function MemesQuickVoteDialogStatusState(t0) {
  const $ = _c(18);
  const {
    action,
    className,
    description,
    title,
    visual
  } = t0;
  const t1 = `tw-relative tw-flex tw-min-h-full tw-items-center tw-justify-center tw-overflow-hidden tw-bg-[#0c0c0d]/95 tw-px-6 tw-py-10 md:tw-px-8 md:tw-py-12 ${className ?? ""}`;
  let t2;
  if ($[0] !== className) {
    t2 = className ? {
      animationDelay: `${QUICK_VOTE_RESTART_VISIBILITY_DELAY_MS}ms`,
      animationFillMode: "both"
    } : undefined;
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-1/2 tw-h-72 tw-w-72 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-primary-500/10 tw-blur-[84px]" />;
    t4 = <div className="tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-1/2 tw-h-44 tw-w-44 -tw-translate-x-1/2 -tw-translate-y-[58%] tw-rounded-full tw-bg-white/5 tw-blur-[48px]" />;
    t5 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.06),transparent_46%)]" />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== title) {
    t6 = <p className="tw-mb-3 tw-text-2xl tw-font-semibold tw-tracking-tight tw-text-white md:tw-text-[1.75rem]">{title}</p>;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== description) {
    t7 = <p className="tw-mx-auto tw-mb-8 tw-max-w-sm tw-text-sm tw-leading-6 tw-text-iron-400 md:tw-text-[15px]">{description}</p>;
    $[7] = description;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== action || $[10] !== t6 || $[11] !== t7 || $[12] !== visual) {
    t8 = <div className="tw-relative tw-z-10 tw-flex tw-w-full tw-max-w-md tw-flex-col tw-items-center tw-text-center">{visual}{t6}{t7}{action}</div>;
    $[9] = action;
    $[10] = t6;
    $[11] = t7;
    $[12] = visual;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t8) {
    t9 = <div className={t1} style={t2}>{t3}{t4}{t5}{t8}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
export function MemesQuickVoteDialogDoneState(t0) {
  const $ = _c(9);
  const {
    description,
    onClose,
    title
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <button type="button" data-autofocus="true" onClick={onClose} className="tw-inline-flex tw-h-11 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.05] tw-px-6 tw-text-sm tw-font-semibold tw-text-iron-100 tw-transition-all active:tw-scale-[0.98] desktop-hover:hover:tw-border-white/15 desktop-hover:hover:tw-bg-white/[0.08]">Close</button>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-absolute tw-inset-0 tw-rounded-full tw-bg-primary-500/10 tw-blur-2xl" />;
    t3 = <div className="tw-absolute tw-inset-3 tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-white/[0.03] tw-backdrop-blur-md" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-relative tw-mx-auto tw-mb-8 tw-flex tw-size-24 tw-items-center tw-justify-center md:tw-size-28">{t2}{t3}<div className="tw-relative tw-flex tw-size-20 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-black/50 tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] md:tw-size-24"><CheckCircleIcon className="tw-size-10 tw-text-iron-100 md:tw-size-12" /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description || $[6] !== t1 || $[7] !== title) {
    t5 = <MemesQuickVoteDialogStatusState action={t1} description={description} title={title} visual={t4} />;
    $[5] = description;
    $[6] = t1;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export function MemesQuickVoteDialogRestartState() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-absolute tw-inset-0 tw-rounded-full tw-bg-primary-500/10 tw-blur-2xl" />;
    t1 = <div className="tw-absolute tw-inset-3 tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-white/[0.03] tw-backdrop-blur-md" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-relative tw-mx-auto tw-mb-8 tw-flex tw-size-24 tw-items-center tw-justify-center md:tw-size-28">{t0}{t1}<div className="tw-relative tw-flex tw-size-20 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-black/50 tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] md:tw-size-24"><div className="tw-size-9 tw-animate-spin tw-rounded-full tw-border-[3px] tw-border-solid tw-border-white/10 tw-border-r-primary-400 tw-border-t-primary-400 md:tw-size-10" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MemesQuickVoteDialogStatusState className="tw-animate-in tw-fade-in tw-duration-150" description={"You\u2019ve reached the end of this round."} title="Starting over" visual={t2} action={<div className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.04] tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-iron-300"><span className="tw-size-2 tw-rounded-full tw-bg-primary-400" /><span>Loading next memes...</span></div>} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function MemesQuickVoteDialogErrorState(t0) {
  const $ = _c(4);
  const {
    onRetry
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-white">Couldn't load quick vote</p>;
    t2 = <p className="tw-mb-4 tw-text-sm tw-text-iron-400">Quick vote couldn't load the next meme. Try again.</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onRetry) {
    t3 = <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-py-8"><div className="tw-w-full tw-max-w-xl tw-rounded-[1.75rem] tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.03] tw-px-6 tw-py-10 tw-text-center tw-shadow-[0_24px_60px_rgba(0,0,0,0.35)] tw-backdrop-blur-sm">{t1}{t2}<button type="button" onClick={onRetry} className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-transition-colors desktop-hover:hover:tw-border-white/20 desktop-hover:hover:tw-bg-white/10">Try again</button></div></div>;
    $[2] = onRetry;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}